const displayForm = ( forms ) => {
  for ( let i = 0; i < forms.length; i++ ) {
    if ( i >= Number( inputNumber.value ) ) {
      forms[ i ].style.display = 'none';
    } else {
      forms[ i ].style.display = 'grid';
    }
  }
};

const displayFormDeux = ( forms, selectedForm, removedForm ) => {
  const value = Number( selectedForm ) + 1;
  forms.forEach( ( form ) => {
    const attribute = form.getAttribute( 'data-form' );
    if ( value === Number( attribute ) ) {
      form.style.display = 'grid';
    }
  } );
};

const currentDisplayedForm = ( forms ) => {
  let displayed = 0;
  forms.forEach( ( form ) => {
    if ( form.style.display === 'grid' ) {
      displayed = Number( form.getAttribute( 'data-form' ) );
    }
  } );
  return displayed;
};

export { displayForm, displayFormDeux, currentDisplayedForm };
